import { makeAutoObservable } from 'mobx'
import { IdentityTokenAttributes } from 'types/__generated__/api'
import { CamelCaseKeys } from 'types/helpers'

import { ShopIdentityTokensApi } from 'shop/api/identityTokens.api'
import { SellerIdentityTokensApi } from '../../cabinet/api/identityTokens.api'
import { PayerIdentityTokensApi } from '../../payer/api/identityTokens.api'

export type IdentityTokenContext = 'shop' | 'payer' | 'seller'

type IdentityToken = CamelCaseKeys<IdentityTokenAttributes>
export class IdentityTokensStore {
  api: ShopIdentityTokensApi | PayerIdentityTokensApi | SellerIdentityTokensApi
  responseData?: IdentityToken
  isLoading = false

  constructor(api: ShopIdentityTokensApi | PayerIdentityTokensApi | SellerIdentityTokensApi) {
    this.api = api
    makeAutoObservable(this)
  }

  setLoading(value: boolean) {
    this.isLoading = value
  }
  setData(data: IdentityToken) {
    this.responseData = data
  }

  fetchIdentityToken = async (params: {
    context: IdentityTokenContext
    sellerSlug?: string
    sellerId?: string
    partnerSlug: string
  }) => {
    this.setLoading(true)
    try {
      if (params.context === 'shop') {
        const resp = await (this.api as ShopIdentityTokensApi).fetchIdentityToken({
          sellerSlug: params.sellerSlug || '',
          partnerSlug: params.partnerSlug,
        })
        const payload = (resp as any)?.data || resp
        if (payload?.identityToken) {
          this.setData(payload as IdentityToken)
          return payload as IdentityToken
        }
        return null
      }

      if (params.context === 'payer') {
        if (!params.sellerId) {
          return null
        }

        const resp = await (this.api as PayerIdentityTokensApi).fetchIdentityToken({
          partnerSlug: params.partnerSlug,
          sellerId: params.sellerId,
        })
        const payload = (resp as any)?.data || resp
        if (payload?.identityToken) {
          this.setData(payload as IdentityToken)
          return payload as IdentityToken
        }
      }

      if (params.context === 'seller') {
        const resp = await (this.api as SellerIdentityTokensApi).fetchIdentityToken({
          partnerSlug: params.partnerSlug,
        })
        const payload = (resp as any)?.data || resp
        if (payload?.identityToken) {
          this.setData(payload as IdentityToken)
          return payload as IdentityToken
        }
      }

      return null
    } finally {
      this.setLoading(false)
    }
  }

  resolveToken = async (params: {
    context: IdentityTokenContext
    sellerSlug?: string
    sellerId?: string
    partnerSlug: string
  }): Promise<string | null> => {
    const payload = await this.fetchIdentityToken(params)
    return payload?.identityToken || null
  }
}
